import { getImageUrl } from '@/utils/images';

export default ({
  name,
  description,
  images,
  producer,
  url,
  price,
  isAvailable,
  sku,
}) => {
  const hasPrice = price && price !== '0.0';

  const baseData = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name,
    image: images.map(image => getImageUrl(image)),
    description,
    sku,
    brand: {
      '@type': 'Organization',
      name: producer,
    },
  };

  const data = hasPrice
    ? {
        ...baseData,
        offers: {
          '@type': 'Offer',
          url,
          priceCurrency: 'EUR',
          price,
          itemCondition: 'https://schema.org/NewCondition',
          availability: isAvailable
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
          seller: {
            '@type': 'Organization',
            name: 'Wine Wine Wine',
          },
        },
      }
    : baseData;

  return data;
};
